import { z } from "zod";

// Hand-written to avoid drizzle-zod + Zod 3.25 incompatibility (.pick().extend() throws at module init)
export const goalTaskFormSchema = z.object({
  title: z.string().min(1, "Title is required"),
  description: z.string().optional(),
  dueDate: z.string().optional(),
  showOnMainTaskPage: z.boolean().optional(),
  category: z.string().default("Uncategorized"),
});

export type GoalTaskFormInput = z.input<typeof goalTaskFormSchema>;
export type GoalTaskFormData = z.output<typeof goalTaskFormSchema>;
